export default __webpack_public_path__ + "static/media/mozilla-icon-bw-rgb.d4986070.svg";